<div (click)="ovarlayClickJS()" *ngIf="showOverlay && isShowCascadebar && isJS" class="c-navigation__overlay"></div>
<a class="c-navigation__overlay" *ngIf="showOverlay && !isJS" 
[routerLink]="currentUrl" [queryParams]="{'menuHierarchy':activeMenuHierarchy}"></a>
<maced-menubar id="Menubar" *ngIf="isShowMenubar" [menuList]="menuList" [isShowExpandCollapse]="false" [optInStatusIcon]="optInStatusIcon"
    [isMenubarExpand]="true" (closeMenubarEvent)="onCloseMenubar()" (menuEvent)="onClickMenu($event)" [isThemeMenubarExpand]="isThemeMenubarExpand"
    (moreMenuEvent)="onClickMoreMenu()" [hasTitleBar]="false"  [hasThemeOption]="hasThemeOption" [themeMenu]="themeMenu">
</maced-menubar>
<div class="c-navigation__cascade" [ngClass]="{'c-navigation__cascade--without-menubar': !isShowMenubar}">
    <ng-container *ngIf="isShowCascadebar">
        <ng-container *ngFor="let cascadeMenu of cascadeMenus;let i = index">
            <maced-cascade-menubar [attr.data-id]="i" [cascadeMenubarId]="'CascadeMenubar' + i" [cascadeMenubarLabel]="cascadeMenubarLabel"
                [cascadeMenuList]="cascadeMenu.menus" (menuEvent)="onClickCascadeMenu($event,i)"
                [backUrl]="getBackUrl()" [backQueryParams]="getBackQueryParam(cascadeMenu)"
                (backEvent)="onClickCascadeBack(i)" (closeEvent)="onClickCascadeClose()" [hasBackButton]="hasBackButton"
                [hasCloseButton]="false" [isCascadeThemeOpens]="isCascadeThemeOpens" [hasTitleBar]="hasTitleBar(i)" [hasBreadcrumbs]="hasBreadcrumbs()"
                *ngIf="cascadeMenu.isVisible">
                <ng-container ngProjectAs="[cascadeMenubarLabel]">
                    <h1 [ngClass]="{'c-navigation-cascading__title-theme-text--small': !isJS}">{{cascadeMenubarLabel}}</h1>
                </ng-container>
                <ng-container ngProjectAs="[breadcrumbsPanel]">
                    <maced-breadcrumbs [id]="breadcrumbsContainer" [linksData]="breadcrumbsName"
                        [isLinksClickable]="isLinksClickable" [nextIconClass]="nextIconClass"
                        [numberOfLinksVisible]="numberOfLinksVisible" [breadCrumbLimit]='breadCrumbLimit'>
                    </maced-breadcrumbs>
                </ng-container>
            </maced-cascade-menubar>
        </ng-container>
    </ng-container>
</div>